/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SiteNavDropdownContent_navigationModule = {
    readonly imageUrl: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavDropdownImageModule_navigationModule">;
    readonly " $refType": "SiteNavDropdownContent_navigationModule";
};
export type SiteNavDropdownContent_navigationModule$data = SiteNavDropdownContent_navigationModule;
export type SiteNavDropdownContent_navigationModule$key = {
    readonly " $data"?: SiteNavDropdownContent_navigationModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavDropdownContent_navigationModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SiteNavDropdownContent_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownImageModule_navigationModule",
      "args": null
    }
  ]
};
(node as any).hash = '1b494936a181d3695e6f453d32225b08';
export default node;
